import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nyse-exhibit-b',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nyse-exhibit-b.component.html',
})
export class NyseExhibitBComponent {
  @Input({ required: true }) vendorName!: string;
}
